import React from 'react';
import {
  ButtonContainer,
  LineSeparator,
  VerifyEmailDisplay,
  VerifyEmailHeader,
  VerifyEmailSubHeader,
} from './VerifyEmailWallStyles';
import OTPInput from '../otp/OTPInput';
import { FONT_FAMILIES } from '../../theme/material/constants';
import Button from '../../atoms/buttons/Button';
import { verifyChangeNewEmail, verifyEmailOtpAction } from '../../actions/authActions';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store';
import { useNavigate } from 'react-router-dom';
import colors from '../../theme/colors';
import Loader from '../../atoms/loader/Loader';
import { isEmpty } from '../../utils/helpers';

interface IVerifyEmailStepProps {
  email: string;
  hasUnVerifiedEmail?: boolean;
  setStep: (step: string) => void;
  setEmail: (email: string) => void;
  data: any;
  isFetching: boolean;
}

const VerifyEmailOtpStep: React.FC<IVerifyEmailStepProps> = ({
  email,
  setStep,
  setEmail,
  data,
  hasUnVerifiedEmail,
  isFetching,
}) => {
  const [otpValue, setOTPValue] = React.useState('');

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const emailVerifyData = useSelector((state: RootState) => state.auth.emailVerifyWallData);

  const handleSubmit = (otp): void => {
    dispatch(verifyEmailOtpAction(emailVerifyData.otpToken, email, otp, 'verify_email_wall', navigate));
  };

  const handleBotButtonClick = (): void => {
    //we will call reset-otp API for bot detection modal in phase 3
    setOTPValue('');
    setEmail(hasUnVerifiedEmail ? data?.email : '');
    dispatch(verifyChangeNewEmail(data?.email, 'verify_email_wall', true));
    setStep(hasUnVerifiedEmail ? 'verify_otp' : 'verify_email');
  };

  return (
    <div>
      <VerifyEmailHeader>{`Let's get verified!`}</VerifyEmailHeader>
      <VerifyEmailSubHeader>{`We’ve sent a one time passcode to:`}</VerifyEmailSubHeader>
      <VerifyEmailDisplay>{email}</VerifyEmailDisplay>
      <LineSeparator />
      {isFetching ? (
        <Loader active={true} />
      ) : (
        <OTPInput
          otpValue={otpValue}
          emailVerifyData={emailVerifyData}
          otpStatus={data?.status || ''}
          resendOTPTitle={'Didn’t get a code?'}
          setOTPValue={setOTPValue}
          handleOTPAutoSubmit={otp => handleSubmit(otp)}
          type={'verify_email_wall'}
          handleBotButtonClick={handleBotButtonClick}
        />
      )}

      <ButtonContainer>
        <Button
          buttonType="primaryRed"
          type="button"
          onClick={() => handleSubmit(otpValue)}
          disabled={
            (data && data.hasError) || isEmpty(otpValue) || emailVerifyData?.is_last_attempt || otpValue.length < 6
          }
          customStyle={{
            fontFamily: FONT_FAMILIES.primary,
            margin: '0 auto',
            fontSize: 14,
            fontWeight: 600,
            lineHeight: '16px',
            padding: '12px 22px',
            minWidth: '192px',
            marginBottom: 15,
            borderRadius: '4px !important',
            // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
            '&:disabled': {
              background: `${colors.gray['200']} !important`,
              border: 'none',
              color: '#fff !important',
            },
          }}
        >
          Next
        </Button>
      </ButtonContainer>
    </div>
  );
};

export default VerifyEmailOtpStep;
